import { Button, ButtonVariant, Icon } from "@blueprintjs/core"
import { useEffect, useState } from "react"
import { ID } from "src/libs/interfaces/layouts"
import { VerticalType } from "src/libs/scalars/interface/IScalarForm"
import Scalar from "src/libs/scalars/scalars/Scalar"
import { ICard } from "../../data/interfaces"
import { schema } from "../../data/schema"
import { ICompositeWidgetProps } from "../LandingCompositeWidget"
import SingleCardScalar from "./SingleCardScalar"

/* Protopia Ecosystem component */
export interface ICardScalarProps extends ICompositeWidgetProps {
   
}
const CardScalar = (props: ICardScalarProps): JSX.Element => {  
    return <>
        <Scalar  
            value={ props.value }
            editable={props.editable }
            field={props.field}
            notClear
            rowClassName="width-auto"
            vertical={ VerticalType.VERTICAL }
            enabledForm={ <CardScalarEnabled {...props} /> }  
            desabledForm={ <CardScalarDisable {...props} /> }  
            subMenus={props.subMenus}
            onSubMenu={props.onSubmenu}  
            onChange={props.onChange}
        />
    </>
}
export default CardScalar

const CardScalarDisable = (props: ICompositeWidgetProps): JSX.Element => { 
    return <div className="d-flex flex-wrap">{ "CARD" }</div>
}


const CardScalarEnabled = (props: ICompositeWidgetProps): JSX.Element => {
    const [value, setValue] = useState<any[]>( props.value || [] ) 
    useEffect(() => {
        setValue( props.value || [] )
    }, [props.value])
    
    const onPrev = (id: ID) => {
        const cards = [...value]
        const index = cards.findIndex(card => card.id === id)
        const card = cards[index]
        cards.splice(index, 1)
        cards.splice(index - 1, 0, card) 
        if( !!props.onChange ) {
            props.onChange(cards, props.field, "")
        } 
    }
    const onNext = (id: ID) => {
        const cards = [...value]
        const index = cards.findIndex(card => card.id === id)
        const card = cards[index]
        cards.splice(index, 1)
        cards.splice(index + 1, 0, card)  
        setValue(cards)
        if( !!props.onChange ) {
            props.onChange(cards, props.field, "")
        } 

    }
    const duplicate = (id: ID) => {
        const cards = [...value]
        const index = cards.findIndex(card => card.id === id)
        const card = cards[index]
        cards.splice(index, 0, card)    
        setValue(cards)
        if( !!props.onChange ) {
            props.onChange(cards, props.field, "")
        } 
    }
    const onRemove = (id: ID) => { 
        const cards = value.filter(card => card.id !== id)
        setValue(cards)
        if( !!props.onChange ) {
            props.onChange(cards, props.field, "")
        }
    }
    const onChange = (id: ID, _value: ICard) => {
        const cards =  value.map(card => {
            if(card.id === id) {
                return _value
            }
            return card
        })  
        setValue(cards)
        if( !!props.onChange ) {
            props.onChange(cards, props.field, "")
        } 
    } 
    const onAdd = (type: string, n:number, ) => {

    }  
    return <div className="w-100 mb-3 px-3"> 
        <div className=" overflow-y-auto d-flex flex-wrap p-2" style={{maxHeight: 600}}>
            { 
                value.map((v: ICard, i: number) => {
                    return <SingleCardScalar
                        item={ v } 
                        id={ v.id }  
                        key={ v.id } 
                        origin={{ ...props.origin, cards: value }} 
                        i={ i }
                        sectionId={ props.sectionId || "-1"}
                        schema={ schema().Card }  
                        onChange={ onChange }
                        onPrev={ onPrev }
                        onNext={ onNext }
                        onRemove={ onRemove }
                        duplicate={ duplicate }
                    />
                })
            }
            <AddCardBtn onAdd={onAdd} />
        </div> 
    </div>
}

export const AddCardBtn = ({onAdd}: any) => {
    return <Button className=' btn-stretch m-1' variant={ButtonVariant.MINIMAL}>
        <div className="square2 flex-centered">
           <Icon icon="plus" />
        </div>
    </Button>
}